import React, { useEffect, useState } from 'react'
import { Col, Divider, Row, Typography } from 'antd'
import AliceCarousel from 'react-alice-carousel'
import ReactPlayer from 'react-player/vimeo'
import { HeaderHero, SEO } from './components'
import { CAREERS_BREAK_POINTS, EMPLOYEES_VIDEO } from '../constants'
import { useWindowSize } from '../utils'

import CareersStyle from '../../styles/Careers.module.css'
import 'react-alice-carousel/lib/alice-carousel.css'

const tabletImage = 'hero/careers/Careers_1024x300-no-copy.jpg'
const desktopImage = 'hero/careers/Careers_1440x300-no-copy.jpg'
const largeScreenImage = 'hero/careers/Careers_1620x300-no-copy.jpg'
const xtraLargeScreenImage = 'hero/careers/Careers_1960x300-no-copy.jpg'
const smallImage = 'hero/careers/Careers_375x188.jpg'
const smallImage390 = 'hero/careers/Careers_390x188.jpg'
const mobileImage = 'hero/careers/Careers_428x188.jpg'
const mobileImage768 = 'hero/careers/Careers_768x300-no-copy.jpg'

const { Title, Text } = Typography

const Careers = () => {
  const windowSize = useWindowSize()
  const [carousalItems, setCarousalItems] = useState()

  useEffect(() => {
    if (!carousalItems) {
      const carousalItems = EMPLOYEES_VIDEO
        ? EMPLOYEES_VIDEO.map((item, index) => (
            <>
              <ReactPlayer key={index} className={`${CareersStyle["react-player"]}`} controls url={item.url} />
              <div className={`${CareersStyle["video-player-below-text"]}`}>
                <p className={`${CareersStyle["video-title"]}`}>{item.employeeName}</p>
                <p className={`${CareersStyle["video-sub-title"]}`}>{item.employeeRole}</p>
              </div>
            </>
          ))
        : []
      setCarousalItems(carousalItems)
    }
  }, [])

  const isMobile = windowSize.width > 1024

  return (
    <>
      <SEO
        description="Join the CURE team and contribute to our future success. See open positions and the benefits of working here."
        title="Careers at CURE Auto Insurance"
        url="/careers"
      />
      <div className={`${CareersStyle["careers-container"]}`}>
        <HeaderHero
          desktopImage={desktopImage}
          largeScreenImage={largeScreenImage}
          mobileImage={mobileImage}
          mobileImage768={mobileImage768}
          smallImage={smallImage}
          smallImage390={smallImage390}
          tabletImage={tabletImage}
          title="CAREERS"
          xtraLargeScreenImage={xtraLargeScreenImage}
          alt={"Careers and Jobs at CURE auto insurance"}
        />
        <div className={`${CareersStyle["careers-inner-container"]} page-text-margin`}>
          <Row>
            <Col />
            <Col>
              <Row>
                <Col lg={20} xl={20} xs={24}>
                  <Text className={`${CareersStyle["career-title"]}`}>Make An Impact</Text>
                  <br />
                  <Text className={`${CareersStyle["career-sub-text"]}`}>
                    CURE realizes that serving responsible drivers requires the most outstanding employees.
                    <br />
                    If you would like to join our team and contribute to our future success, we welcome your
                    application.
                  </Text>
                </Col>
                <Col className={`${CareersStyle["available-careers"]}`} lg={4} xl={4} xs={24}>
                  <a
                    className={`${CareersStyle["link"]}`}
                    href="https://cure.candridsoftware.com"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    <Title level={3}>OPEN POSITIONS</Title>
                  </a>
                </Col>
              </Row>
              <Divider />
              <Row>
                <Col span={24}>
                  <Row>
                    <Text className={`${CareersStyle["career-title"]}`}>Rewards and Benefits</Text>
                    <Text className={`${CareersStyle["career-sub-text"]}`}>
                      Competitive salaries and benefits recognize the role you play in our success. These benefits
                      combined with a hybrid work model allow for a great work and life integration.
                    </Text>
                  </Row>
                </Col>
                <Col lg={0} md={0} sm={0} xl={0} xs={24}>
                  <Row>
                    <Text className={`${CareersStyle["career-title"]} ${CareersStyle["unbold"]}`}>401(k)</Text>
                    <Text className={`${CareersStyle["career-sub-text"]}`}>
                      Full-time new hires become eligible to enroll in the CURE 401(k) Plan on the first of the month
                      after 3 months of employment. CURE helps you save for retirement by matching $0.75 on every $1.00
                      you contribute up to 6% of your salary deferral.
                    </Text>
                  </Row>
                  <Row>
                    <Text className={`${CareersStyle["career-title"]} ${CareersStyle["unbold"]}`}>Medical, Dental, Vision</Text>
                    <Text className={`${CareersStyle["career-sub-text"]}`}>
                      CURE offers generous medical plan options and comprehensive vision and dental plans. You are
                      eligible to enroll on the first of the month after 30 days of employment.
                    </Text>
                  </Row>
                  <Row>
                    <Text className={`${CareersStyle["career-title"]} ${CareersStyle["unbold"]}`}>Paid Time Off</Text>
                    <Text className={`${CareersStyle["career-sub-text"]}`}>
                      CURE offers paid time off for many full and half day holidays, as well generous personal, vacation
                      and sick time.
                    </Text>
                  </Row>
                  <Row>
                    <Text className={`${CareersStyle["career-title"]} ${CareersStyle["unbold"]}`}>Additional Benefits</Text>
                    <Text className={`${CareersStyle["career-sub-text"]}`}>
                      Employees are automatically enrolled in basic life insurance and accident coverage at no cost.
                      Supplemental term life and AD&D insurance for employees and dependents are available at an
                      additional cost.
                    </Text>
                  </Row>
                  <Row>
                    <Text className={`${CareersStyle["career-title"]} ${CareersStyle["unbold"]}`}>Long Term Employee Bonus Program</Text>
                    <Text className={`${CareersStyle["career-sub-text"]}`}>
                      Full-time employees who have been continuously employed for a minimum of 10 years receive a Long
                      Term Employee bonus each year on their anniversary date. Those at 20 years or more also receive
                      additional vacation time above their accrual amounts and an anniversary gift.
                    </Text>
                  </Row>
                  <Row>
                    <Text className={`${CareersStyle["career-title"]} ${CareersStyle["unbold"]} ${CareersStyle["wrap-text"]}`} style={{ marginBottom: 4 }}>
                      Carnegie Center (for Princeton office employees)
                    </Text>
                    <Text className={`${CareersStyle["career-sub-text"]}`}>
                      Carnegie Center offers numerous amenities including outdoor seating, walking paths, basketball and
                      volleyball courts and leagues. There are also several full-service cafés within the Carnegie
                      Center buildings plus fun summer concerts and other events.
                    </Text>
                  </Row>
                </Col>
                <Col lg={24} md={24} sm={24} xl={24} xs={0}>
                  <Row>
                    <Col className={`${CareersStyle["career-box"]}`} xl={8}>
                      <Row>
                        <Text className={`${CareersStyle["career-text"]}`}>401(k)</Text>
                        <Text className={`${CareersStyle["career-sub-text"]}`}>
                          Full-time new hires become eligible to enroll in the CURE 401(k) Plan on the first of the
                          month after 3 months of employment. CURE helps you save for retirement by matching $0.75 on
                          every $1.00 you contribute up to 6% of your salary deferral.
                        </Text>
                      </Row>
                    </Col>
                    <Col className={`${CareersStyle["career-box"]}`} xl={8}>
                      <Row>
                        <Text className={`${CareersStyle["career-text"]}`}>Medical, Dental, Vision</Text>
                      </Row>
                      <Text className={`${CareersStyle["career-sub-text"]}`}>
                        CURE offers generous medical plan options and comprehensive vision and dental plans. You are
                        eligible to enroll on the first of the month after 30 days of employment.
                      </Text>
                    </Col>
                    <Col className={`${CareersStyle["career-box"]}`} xl={8}>
                      <Row>
                        <Text className={`${CareersStyle["career-text"]}`}>Paid Time Off</Text>
                      </Row>
                      <Text className={`${CareersStyle["career-sub-text"]}`}>
                        CURE offers paid time off for many full and half day holidays, as well generous personal,
                        vacation and sick time.
                      </Text>
                    </Col>
                  </Row>
                </Col>
                <Col lg={24} md={24} sm={24} xl={24} xs={0}>
                  <Row>
                    <Col className={`${CareersStyle["career-box"]}`} xl={8}>
                      <Row>
                        <Text className={`${CareersStyle["career-text"]}`}>Additional Benefits</Text>
                      </Row>
                      <Text className={`${CareersStyle["career-sub-text"]}`}>
                        Employees are automatically enrolled in basic life insurance and accident coverage at no cost.
                        Supplemental term life and AD&D insurance for employees and dependents are available at an
                        additional cost.
                      </Text>
                    </Col>
                    <Col className={`${CareersStyle["career-box"]}`} xl={8}>
                      <Row>
                        <Text className={`${CareersStyle["career-text"]}`}>Long Term Employee Bonus Program</Text>
                      </Row>
                      <Text className={`${CareersStyle["career-sub-text"]}`}>
                        Full-time employees who have been continuously employed for a minimum of 10 years receive a Long
                        Term Employee bonus each year on their anniversary date. Those at 20 years or more also receive
                        additional vacation time above their accrual amounts and an anniversary gift.
                      </Text>
                    </Col>
                    <Col className={`${CareersStyle["career-box"]}`} xl={8}>
                      <Row>
                        <Text className={`${CareersStyle["career-text"]}`}>Carnegie Center (for Princeton office employees)</Text>
                      </Row>
                      <Text className={`${CareersStyle["career-sub-text"]}`}>
                        Carnegie Center offers numerous amenities including outdoor seating, walking paths, basketball
                        and volleyball courts and leagues. There are also several full-service cafés within the Carnegie
                        Center buildings plus fun summer concerts and other events.
                      </Text>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Divider />
              <Row>
                <Col span={24}>
                  <Row>
                    <Text className={`${CareersStyle["career-title"]}`}>Hear From Our Employees</Text>
                  </Row>
                </Col>
              </Row>
              <Row className={`${CareersStyle["career-video-carousal"]} ${CareersStyle["margin-bottom-12"]}`}>
                <AliceCarousel
                  animationDuration={3000}
                  autoPlayDirection="ltr"
                  autoPlayInterval={5000}
                  autoPlayStrategy="none"
                  controlsStrategy="alternate"
                  disableAutoPlayOnAction={true}
                  disableButtonsControls={isMobile}
                  disableDotsControls={isMobile}
                  fadeOutAnimation={true}
                  items={carousalItems}
                  mouseTrackingEnabled={true}
                  responsive={CAREERS_BREAK_POINTS}
                  {...(!isMobile && { infinite: true })}
                />
              </Row>
            </Col>
          </Row>
        </div>
      </div>
    </>
  )
}

Careers.propTypes = {}

export default Careers
